import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * Per-conversation «sound off» preference. This silences the in-app chime +
 * vibration for chosen channels WITHOUT touching Stream's channel mute (which
 * would also drop the channel from unread counts). Backed by an in-memory set
 * for synchronous reads, persisted to AsyncStorage.
 */
const KEY = 'chat_muted_sounds';
let cache = new Set<string>();
let loaded = false;

/** Load persisted muted channels into memory (call once early). */
export async function loadMutedSounds(): Promise<void> {
  if (loaded) return;
  loaded = true;
  try {
    const raw = await AsyncStorage.getItem(KEY);
    if (raw) cache = new Set<string>(JSON.parse(raw));
  } catch {
    /* first run / parse error — empty set */
  }
}

/** Sync check — is the chime muted for this channel cid? */
export function isSoundMuted(cid: string): boolean {
  return cache.has(cid);
}

/** Toggle and persist; returns the new muted state. */
export async function toggleSoundMuted(cid: string): Promise<boolean> {
  if (cache.has(cid)) cache.delete(cid);
  else cache.add(cid);
  try {
    await AsyncStorage.setItem(KEY, JSON.stringify([...cache]));
  } catch {
    /* persistence best-effort */
  }
  return cache.has(cid);
}
